import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { RETURN_URL_STORAGE_KEY } from './app/services/auth/auth.service';

// Capture the deep link (e.g. a worksheet opened in a new tab) as early as
// possible, before Angular/CAL bootstrap can kick off a sign-in redirect that
// always lands back on the app's fixed redirectUri (the site root), which
// would otherwise discard the current path. AuthService restores it once
// sign-in is confirmed.
const currentPath = window.location.pathname + window.location.search;
if (currentPath && currentPath !== '/' && !sessionStorage.getItem(RETURN_URL_STORAGE_KEY)) {
  sessionStorage.setItem(RETURN_URL_STORAGE_KEY, currentPath);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
